<template>
  <div class="patient-page">
    <div class="page-header">
      <h1>患者管理</h1>
      <p>管理系统中的患者信息和数据</p>
    </div>

    <!-- 统计概览 -->
    <div class="patient-stats">
      <div class="stat-card">
        <div class="stat-icon">
          <el-icon><User /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ total || 0 }}</div>
          <div class="stat-label">总用户数</div>
          <!-- <div class="stat-trend positive">周同比 12% ▲</div> -->
        </div>
      </div>
      
      <!-- <div class="stat-card">
        <div class="stat-icon">
          <el-icon><Document /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">8,846</div>
          <div class="stat-label">知识库总量</div>
          <div class="stat-trend positive">+8% 本周</div>
        </div>
      </div> -->
      
      <div class="stat-card">
        <div class="stat-icon">
          <el-icon><TrendCharts /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">{{ Math.floor(total/2) || 0 }}</div>
          <div class="stat-label">今日活跃用户</div>
          <!-- <div class="stat-trend positive">+5% 昨日</div> -->
        </div>
      </div>
      
      <!-- <div class="stat-card">
        <div class="stat-icon">
          <el-icon><Bell /></el-icon>
        </div>
        <div class="stat-content">
          <div class="stat-number">89</div>
          <div class="stat-label">未读通知</div>
          <div class="stat-trend neutral">0% 变化</div>
        </div>
      </div> -->
    </div>

    <!-- 用户列表 -->
    <div class="user-list-section1">
      <div class="section-header">
        <h2>用户列表</h2>
        <div class="header-actions">
          <el-button 
            type="success" 
            :disabled="selectedPatients.length === 0"
            @click="sendNotification"
          >
            <el-icon><Bell /></el-icon>
            发送通知(批量)
          </el-button>
          <el-button type="primary" @click="addPatient">
            <el-icon><Plus /></el-icon>
            新增患者
          </el-button>
        </div>
      </div>

      <!-- 筛选条件 -->
      <div class="filter-section">
        <el-form :model="filterForm" inline>
          <el-form-item label="患者姓名">
            <el-input v-model="filterForm.name" placeholder="请输入患者姓名" clearable />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="filterForm.phone" placeholder="请输入手机号" clearable />
          </el-form-item>
          <el-form-item label="所属机构">
            <el-select
              v-model="filterForm.organizationId"
              placeholder="请选择机构"
              clearable
              filterable
              style="min-width: 200px"
            >
              <el-option
                v-for="org in organizationOptions"
                :key="org.id ?? org.organizationId ?? org.orgId"
                :label="org.name ?? org.orgName ?? org.organizationName ?? (org.id ?? org.organizationId ?? org.orgId)"
                :value="org.id ?? org.organizationId ?? org.orgId"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table :data="patientList" style="width: 100%" @selection-change="handleSelectionChange" :cell-style="{ textAlign: 'center' }" :header-cell-style="{ textAlign: 'center' }">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="编号" />
        <el-table-column prop="name" label="患者姓名"  />
        <el-table-column prop="phone" label="手机号"  />
        <el-table-column prop="age" label="年龄"  />
        <el-table-column prop="gender" label="性别"  />
        <el-table-column prop="organizationName" label="所属机构" />
        <el-table-column label="会员" width="220">
          <template #default="{ row }">
            <el-tag
              :type="row.vipInfo.length > 0 ? 'warning' : 'info'"
              :style="row.vipInfo && row.vipInfo.length > 0 ? 'cursor: pointer;' : ''"
              @click.stop="row.vipInfo && row.vipInfo.length > 0 && openVipDialog(row)"
              :title="row.vipInfo && row.vipInfo.length > 0 ? '查看 VIP 详情' : ''"
            >
              {{ row.vipInfo && row.vipInfo.length > 0 ? `VIP` : '非会员' }}
            </el-tag>
            <span v-if="row.vipStatus === 1 && remainingDays(row) !== null" style="margin-left: 8px; color: #64748b;">
              （剩余时间{{ remainingDays(row) }}天）
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="registerTime" label="注册时间"  sortable />
        <el-table-column label="操作" width="400px">
          <template #default="scope">
            <el-button type="text" @click="editPatient(scope.row)">修改信息</el-button>
            <el-button type="text" @click="openPasswordDialog(scope.row)" style="color: #e6a23c;">修改密码</el-button>
            <el-button type="text" @click="viewChatHistory(scope.row)">查看历史对话</el-button>
            <el-button type="text" @click="openOptionData(scope.row)">智能选项数据</el-button>
            <el-button type="text" @click="deletePatient(scope.row)" style="color: #f56c6c;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 新增/编辑患者对话框 -->
    <el-dialog
      v-model="patientDialogVisible"
      :title="isEdit ? '编辑患者信息' : '新增患者'"
      width="600px"
    >
      <el-form :model="patientForm" label-width="100px">
        <el-form-item label="患者姓名" required>
          <el-input v-model="patientForm.name" placeholder="请输入患者姓名" />
        </el-form-item>
        <el-form-item label="手机号" required>
          <el-input v-model="patientForm.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="所属机构" required>
          <el-select
            v-model="patientForm.organizationId"
            placeholder="请选择机构"
            clearable
            filterable
          >
            <el-option
              v-for="org in organizationOptions"
              :key="org.id ?? org.organizationId ?? org.orgId"
              :label="org.name ?? org.orgName ?? org.organizationName ?? (org.id ?? org.organizationId ?? org.orgId)"
              :value="org.id ?? org.organizationId ?? org.orgId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="干体重(kg)" required>
          <el-input-number v-model="patientForm.dryWeight" :min="0" :max="300" :step="0.1" style="width: 100%" />
        </el-form-item>
        <el-form-item label="性别" required>
          <el-radio-group v-model="patientForm.gender">
            <el-radio :label="0">男</el-radio>
            <el-radio :label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="出生日期" required>
          <el-date-picker
            v-model="patientForm.birthday"
            type="date"
            placeholder="请选择出生日期"
            value-format="YYYY-MM-DD"
            style="width: 100%"
          />
        </el-form-item>
        <!-- <el-form-item label="身份证号">
          <el-input v-model="patientForm.idCard" placeholder="请输入身份证号" />
        </el-form-item> -->
        <!-- <el-form-item label="地址">
          <el-input v-model="patientForm.address" placeholder="请输入地址" />
        </el-form-item> -->
        <el-form-item label="备注">
          <el-input 
            v-model="patientForm.remark" 
            type="textarea" 
            :rows="3"
            placeholder="可选备注，如透析安排、注意事项等"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="patientDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="savePatient">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 修改密码对话框 -->
    <el-dialog v-model="passwordDialogVisible" title="修改密码" width="480px" @closed="resetPasswordForm">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordFormRef" label-width="90px">
        <el-form-item label="患者">
          <span>{{ passwordForm.patientName }}（ID: {{ passwordForm.userId }}）</span>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="passwordForm.password" type="password" placeholder="请输入新密码" show-password />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="passwordSubmitting" @click="submitPasswordUpdate">确定</el-button>
      </template>
    </el-dialog>

    <!-- 发送通知对话框 -->
    <el-dialog
      v-model="doctorCommentDialogVisible"
      title="添加医生意见"
      width="650px"
    >
      <el-form :model="doctorCommentForm" label-width="100px">
        <el-form-item label="ai内容" >
          <el-input
            v-model="currentAiNotification"
            type="textarea"
            :rows="10"
            placeholder="请输入医生意见"
            readonly
          />
        </el-form-item>
        <el-form-item label="意见内容" required>
          <el-input
            v-model="doctorCommentForm.content"
            type="textarea"
            :rows="4"
            placeholder="请输入医生意见"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="doctorCommentDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitDoctorComment">确认</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="notificationDialogVisible"
      title="发送通知"
      width="600px"
    >

    
      <el-form :model="notificationForm" label-width="100px" >
        <el-form-item label="标题" required>
          <el-input v-model="notificationForm.title" placeholder="请输入通知标题"/>
        </el-form-item>
        <el-form-item label="通知内容" required>
          <el-input
            v-model="notificationForm.content"
            type="textarea"
            :rows="4"
            placeholder="请输入通知内容"
          />
        </el-form-item>
        
        <el-form-item label="接收用户" required>
          <div class="selected-users">
            <el-tag
              v-for="user in selectedPatients"
              :key="user.id"
              closable
              @close="removeUser(user)"
              style="margin-right: 8px; margin-bottom: 8px;"
            >
              {{ user.name }} ({{ user.phone }})
            </el-tag>
          </div>
          <div class="user-count">
            已选择 {{ selectedPatients.length }} 位用户
          </div>
        </el-form-item>
        
        <el-form-item label="发送时间" required>
          <el-date-picker
            v-model="notificationForm.sendTime"
            type="datetime"
            placeholder="选择发送时间（留空为立即发送）"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="notificationDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="sendNotificationSubmit" :loading="sending">发送</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- VIP 详情弹窗 -->
    <el-dialog
      v-model="vipDialogVisible"
      :title="`VIP 信息 - ${vipPatientName}`"
      width="540px"
    >
      <div v-if="!vipDetails || vipDetails.length === 0" style="padding: 20px;">
        <el-empty description="暂无 VIP 信息" />
      </div>
      <div v-else>
        <el-timeline>
          <el-timeline-item v-for="(vip, idx) in vipDetails" :key="idx">
            <div style="display:flex;justify-content:space-between;align-items:center;gap:12px;">
              <div>
                <div style="font-weight:600">{{ vip.vipName || ('VIP#' + (vip.vipType ?? '')) }}</div>
                <!-- <div style="color:#6b7280;margin-top:6px;">类型: {{ vipTypeLabel(vip.vipType) }}</div> -->
              </div>
              <div style="text-align:right;color:#4b5563;">
                <div>开始：{{ vip.startTime || '-' }}</div>
                <div>结束：{{ vip.endTime || '-' }}</div>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="vipDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 查看历史对话对话框 -->
    <el-dialog
      v-model="chatHistoryDialogVisible"
      width="800px"
      top="5vh"
    >
      <template #header>
        <div class="dialog-header">
          <span class="dialog-title">{{ currentPatientName }} 的历史对话</span>
          <div class="agent-selector">
            <el-radio-group v-model="selectedAgentId" @change="handleAgentChange">
              <el-radio :label="1">小助手</el-radio>
              <el-radio :label="2">体重小助手</el-radio>
            </el-radio-group>
          </div>
        </div>
      </template>
      
      <div 
        class="chat-history-container"
        ref="chatHistoryContainer"
      >
        <!-- 加载更多记录按钮 -->
        <div v-if="hasMoreChatHistory && !isLoadingMore" class="load-more-button" @click="loadMoreChatHistory">
          <el-icon><ArrowUp /></el-icon>
          <span>加载更多记录</span>
        </div>
        
        <!-- 加载更多的提示 -->
        <div v-if="isLoadingMore" class="loading-more">
          <el-icon class="is-loading"><Loading /></el-icon>
          <span>加载更多记录中...</span>
        </div>
        
        <div v-if="chatHistoryLoading && !isLoadingMore" class="loading-container">
          <el-icon class="is-loading"><Loading /></el-icon>
          <span>加载对话记录中...</span>
        </div>
        
        <div v-else-if="chatHistoryList.length === 0 && !chatHistoryLoading" class="empty-chat">
          <el-empty description="暂无对话记录" />
        </div>
        
        <div v-else class="chat-messages">
          <div 
            v-for="(message, index) in chatHistoryList" 
            :key="`${message.id || index}-${message.timestamp}`"
            class="chat-message"
            :class="{ 'user-message': message.role === 'user', 'assistant-message': message.role === 'assistant' }"
          >
            <div class="message-header">
              <span class="message-role">
                {{ message.role === 'user' ? '患者' : (selectedAgentId === 1 ? 'AI助手' : '体重小助手') }}
              </span>
              <span class="message-time">
                {{ formatTime(message.timestamp || message.createdAt) }}
              </span>
            </div>
            <div class="message-content" v-html="message.content">
            </div>
            <div class="message-actions" v-if="message.role !== 'user'">
              <el-button type="text" @click="openDoctorCommentDialog(message)" >+添加医生意见</el-button>
            </div>
          </div>
        </div>
      </div>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="chatHistoryDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { patientAPI, agentAPI, messageAPI, approvalAPI, organizationAPI } from '@/api'
import { time } from 'echarts'

const router = useRouter()

const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)
const selectedPatients = ref([])
const patientDialogVisible = ref(false)
const isEdit = ref(false)
const passwordDialogVisible = ref(false)
const passwordSubmitting = ref(false)
const passwordFormRef = ref(null)
const passwordForm = reactive({
  userId: null,
  patientName: '',
  password: '',
  confirmPassword: ''
})
const validateConfirmPassword = (_rule, value, callback) => {
  if (!value) {
    callback(new Error('请再次输入新密码'))
  } else if (value !== passwordForm.password) {
    callback(new Error('两次输入的密码不一致'))
  } else {
    callback()
  }
}
const passwordRules = {
  password: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, max: 20, message: '密码长度需在 6-20 位', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, validator: validateConfirmPassword, trigger: 'blur' }
  ]
}
const notificationDialogVisible = ref(false)
const sending = ref(false)
const currentAiNotification = ref(null)
const currentTime= ref(null)

// 添加筛选表单
const filterForm = reactive({
  name: '', // ???????
  phone: '', // ?????
  organizationId: null // ??????
})

// ????????????
const organizationOptions = ref([])

const fetchOrganizationOptions = async () => {
  try {
    const res = await organizationAPI.getList({ pageNum: 1, pageSize: 9999 })
    if (res && res.code === 0) {
      organizationOptions.value = res.data?.records || []
    }
  } catch (err) {
    console.error('????????????', err)
  }
}

const getOrgNameById = (id) => {
  if (id === null || id === undefined || id === '') return '-'
  const matched = organizationOptions.value.find(o => {
    const oid = o.id ?? o.organizationId ?? o.orgId
    return oid != null && String(oid) === String(id)
  })
  return matched?.name ?? matched?.orgName ?? matched?.organizationName ?? String(id)
}

const patientForm = reactive({
  name: '',
  phone: '',
  dryWeight: undefined,
  gender: 0,
  birthday: '',
  idCard: '',
  address: '',
  remark: '',
  organizationId: null
})

const notificationForm = reactive({
  content: '',
  sendTime: null
})

const doctorCommentDialogVisible = ref(false)
const doctorCommentForm = reactive({
  content: '',
  messageId: ''
})

const patientList = ref([])
const loading = ref(false)

const chatHistoryDialogVisible = ref(false)
const chatHistoryList = ref([])
const chatHistoryLoading = ref(false)
const currentPatientId = ref(null)
const currentPatientName = ref('')
const chatHistoryLimit = ref(20) // 每次加载20条记录
const hasMoreChatHistory = ref(true) // 是否还有更多聊天记录

// 添加小助手选择相关变量
const selectedAgentId = ref(1) // 默认选择小助手

// 在 script setup 中添加滚动监听相关的变量和方法
const chatHistoryContainer = ref(null)
const isLoadingMore = ref(false)

const scrollChatToBottom = () => {
  const container = chatHistoryContainer.value
  if (!container) return
  container.scrollTop = container.scrollHeight
}

// VIP 详情相关状态
const vipDialogVisible = ref(false)
const vipDetails = ref([])
const vipPatientName = ref('')

const openVipDialog = (row) => {
  vipDetails.value = (row.vipInfo || []).map(v => ({
    vipType: v.vipType,
    vipName: v.vipName,
    startTime: v.startTime,
    endTime: v.endTime
  }))
  vipPatientName.value = row.name || row.userId || ''
  vipDialogVisible.value = true
}

// vipType 只是一个 id 标识，不代表文本类型；默认显示为 ID，如需映射请替换此函数
const vipTypeLabel = (t) => {
  return t != null ? `ID: ${t}` : '-'
}

// 移除滚动监听方法
// const handleScroll = async (event) => { ... }

const calcAge = (birthday) => {
  if (!birthday) return ''
  const date = new Date(birthday)
  if (isNaN(date.getTime())) return ''
  const today = new Date()
  let age = today.getFullYear() - date.getFullYear()
  const monthDiff = today.getMonth() - date.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
    age--
  }
  return age
}

// 计算会员剩余天数（向下取整），无效或无结束时间返回 null
const remainingDays = (row) => {
  try {
    if (!row || row.vipStatus !== 1) return null
    const end = row._vipEnd || row.vipEndTime
    if (!end) return null
    const endTime = new Date(end).getTime()
    if (Number.isNaN(endTime)) return null
    const now = Date.now()
    const ms = endTime - now
    const days = Math.floor(ms / (1000 * 60 * 60 * 24))
    return days >= 0 ? days : 0
  } catch (_) {
    return null
  }
}

// 获取患者列表
const fetchPatientList = async () => {
  loading.value = true
  try {
    // 构建请求参数
    const params = {
      pageNum: currentPage.value,
      pageSize: pageSize.value
    }
    
    // 添加筛选条件
    if (filterForm.name) {
      params.name = filterForm.name
    }
    if (filterForm.phone) {
      params.phone = filterForm.phone
    }
    if (filterForm.organizationId !== null && filterForm.organizationId !== undefined && filterForm.organizationId !== '') {
      params.organizationId = filterForm.organizationId
    }
    
    const response = await patientAPI.getPatientList(params)
    if (response.code === 0) {
      const records = response.data?.records || []
      patientList.value = records.map(r => ({
        id: r.userId,
        name: r.name,
        phone: r.phone,
        age: calcAge(r.birthday),
        gender: r.gender === 0 ? '男' : '女',
        organizationId: r.organizationId ?? r.orgId ?? r.organization ?? null,
        organizationName: getOrgNameById(r.organizationId ?? r.orgId ?? r.organization),
        registerTime: r.createdAt,
  // 会员信息 (确保 vipInfo 至少为数组，避免模板读取 length 时出错)
  vipInfo: r.vipInfo || [],
  vipLevel: r.vipLevel ?? '-',
  vipStatus: r.vipStatus ?? 0,
  vipStartTime: r.vipStartTime ?? '-',
  vipEndTime: r.vipEndTime ?? '-',
        // 保留原始字段以便编辑
        userId: r.userId,
        birthday: r.birthday,
        dryWeight: r.dryWeight,
        remark: r.remark || '',
        // 原始结束时间，便于计算剩余天数
        _vipEnd: r.vipEndTime || null,
      }))
      total.value = response.data?.total ?? 0
    } else {
      ElMessage.error(response.msg || '获取患者列表失败')
    }
  } catch (error) {
    ElMessage.error('获取患者列表失败')
    console.error('获取患者列表错误:', error)
    // 使用模拟数据作为后备
    patientList.value = [
      {
        id: 210,
        name: '张三',
        phone: '13800138000',
        age: 60,
        gender: '男',
        registerTime: '2017-10-31 23:12:00'
      },
      {
        id: 209,
        name: '李四',
        phone: '13800138001',
        age: 45,
        gender: '女',
        registerTime: '2017-10-30 15:30:00'
      }
    ]
  } finally {
    loading.value = false
  }
}

const handleSelectionChange = (selection) => {
  selectedPatients.value = selection
}

const addPatient = () => {
  isEdit.value = false
  Object.assign(patientForm, {
    name: '',
    phone: '',
    dryWeight: undefined,
    gender: 0,
    birthday: '',
    idCard: '',
    address: '',
    remark: '',
    organizationId: null
  })
  patientDialogVisible.value = true
}

const editPatient = (row) => {
  isEdit.value = true
  Object.assign(patientForm, {
    userId: row.userId,
    name: row.name,
    phone: row.phone,
    dryWeight: row.dryWeight,
    gender: typeof row.gender === 'number' ? row.gender : (row.gender === '男' ? 0 : 1),
    birthday: row.birthday,
    idCard: '',
    address: '',
    remark: row.remark || '',
    organizationId: row.organizationId ?? row.orgId ?? row.organization ?? null
  })
  patientDialogVisible.value = true
}

const openPasswordDialog = (row) => {
  passwordForm.userId = row.userId ?? row.id
  passwordForm.patientName = row.name || ''
  passwordForm.password = ''
  passwordForm.confirmPassword = ''
  passwordDialogVisible.value = true
}

const resetPasswordForm = () => {
  passwordForm.userId = null
  passwordForm.patientName = ''
  passwordForm.password = ''
  passwordForm.confirmPassword = ''
  passwordFormRef.value?.clearValidate()
}

const submitPasswordUpdate = async () => {
  if (!passwordFormRef.value) return
  try {
    await passwordFormRef.value.validate()
  } catch {
    return
  }
  passwordSubmitting.value = true
  try {
    const response = await patientAPI.updatePassword({
      userId: passwordForm.userId,
      password: passwordForm.password
    })
    if (response.code === 0) {
      ElMessage.success('密码修改成功')
      passwordDialogVisible.value = false
    } else {
      ElMessage.error(response.msg || '密码修改失败')
    }
  } catch (error) {
    ElMessage.error('密码修改失败')
    console.error('修改患者密码错误:', error)
  } finally {
    passwordSubmitting.value = false
  }
}

const openOptionData = (row) => {
  const userId = row.userId || row.id
  if (!userId) {
    ElMessage.error('未找到用户ID，无法查看智能选项数据')
    return
  }

  router.push({
    name: 'PatientOptionData',
    params: { userId },
    query: { name: row.name || '', pageNum: 1, pageSize: 20 }
  })
}

const viewChatHistory = async (row) => {
  console.log('查看聊天记录，患者信息:', row)
  currentPatientId.value = row.userId || row.id
  currentPatientName.value = row.name
  selectedAgentId.value = 1 // 重置为默认小助手
  chatHistoryList.value = []
  hasMoreChatHistory.value = true // 重置分页状态
  chatHistoryDialogVisible.value = true
  
  console.log('设置的患者ID:', currentPatientId.value)
  console.log('设置的患者姓名:', currentPatientName.value)
  
  await fetchChatHistory()
  await nextTick()
  scrollChatToBottom()
}

// 处理小助手切换
const handleAgentChange = async () => {
  console.log('切换小助手:', selectedAgentId.value)
  chatHistoryList.value = []
  hasMoreChatHistory.value = true
  await fetchChatHistory()
  await nextTick()
  scrollChatToBottom()
}

// 获取聊天记录
const fetchChatHistory = async (isLoadMore = false) => {
  if (!currentPatientId.value) return
  
  if (isLoadMore) {
    // 加载更多时不需要设置 chatHistoryLoading
    console.log('正在获取更多聊天记录，用户ID:', currentPatientId.value, '小助手ID:', selectedAgentId.value)
  } else {
    chatHistoryLoading.value = true
    console.log('正在获取聊天记录，用户ID:', currentPatientId.value, '小助手ID:', selectedAgentId.value)
  }
  
  try {
    const params = {
      userId: currentPatientId.value,
      limit: 10,
      agentId: selectedAgentId.value // 添加小助手ID参数
    }
    
    // 如果是加载更多，添加firstId参数
    if (isLoadMore && chatHistoryList.value.length > 0) {
      // 获取最上面一条记录的ID
      const firstMessage = chatHistoryList.value[0]
      params.firstId = firstMessage.id || firstMessage.messageId
      console.log('加载更多，firstId:', params.firstId)
    }
    
    const response = await agentAPI.chatHistory(params)
    
    console.log('聊天记录API响应:', response)
    
    if (response.code === 0) {
      // 解析JSON字符串
      let responseData
      if (typeof response.data === 'string') {
        try {
          responseData = JSON.parse(response.data)
        } catch (e) {
          console.error('解析JSON失败:', e)
          responseData = {}
        }
      } else {
        responseData = response.data || {}
      }
      
      const historyData = responseData.data || []
      
      console.log('解析的聊天数据:', historyData)
      
      // 如果没有更多数据了
      if (historyData.length === 0) {
        hasMoreChatHistory.value = false
        if (isLoadMore) {
          ElMessage.info('没有更多聊天记录了')
        }
        return
      }
      
      // 过滤think标签的函数
      const filterThinkTags = (content) => {
        if (!content) return content
        return content
          .replace(/<think>[\s\S]*?<\/think>/g, '')
          .replace(/<hr\s*\/?>/g, '')
          .replace(/^\[system\].*$/gm, '')
          .trim()
      }
      
      // 将API返回的数据转换为前端需要的格式
      const formattedHistory = historyData.map(item => {
        console.log('处理单条记录:', item)
        const messages = []
        
        // 添加用户消息
        if (item.query) {
          const filteredQuery = filterThinkTags(item.query)
          if (filteredQuery && !filteredQuery.startsWith('[system]')) {
            messages.push({
              id: item.id || item.messageId,
              role: 'user',
              content: filteredQuery,
              timestamp: item.created_at ? new Date(item.created_at * 1000).toISOString() : null,
              createdAt: item.created_at ? new Date(item.created_at * 1000).toISOString() : null
            })
          }
        }
        
        // 添加助手消息
        if (item.answer) {
          const filteredAnswer = filterThinkTags(item.answer)
          if (filteredAnswer) {
            messages.push({
              id: item.id || item.messageId,
              role: 'assistant',
              content: filteredAnswer,
              timestamp: item.created_at ? new Date(item.created_at * 1000).toISOString() : null,
              createdAt: item.created_at ? new Date(item.created_at * 1000).toISOString() : null
            })
          }
        }
        
        return messages
      }).flat().filter(msg => msg.content && msg.content.trim())
      
      console.log('格式化后的聊天记录:', formattedHistory)
      
      if (isLoadMore) {
        // 加载更多时，将新数据插入到列表开头
        chatHistoryList.value = [...formattedHistory, ...chatHistoryList.value]
        console.log('已添加更多记录，当前总数:', chatHistoryList.value.length)
      } else {
        // 首次加载时，直接赋值
        chatHistoryList.value = formattedHistory
      }
      
      // 更新分页信息
      hasMoreChatHistory.value = responseData.has_more !== false && formattedHistory.length > 0
      console.log('更新分页状态，hasMore:', hasMoreChatHistory.value)
      if (!isLoadMore) {
        await nextTick()
        scrollChatToBottom()
      }
    } else {
      console.error('API返回错误:', response.msg)
      if (!isLoadMore) {
        ElMessage.error(response.msg || '获取对话记录失败')
      }
    }
  } catch (error) {
    console.error('获取聊天记录错误:', error)
    if (!isLoadMore) {
      ElMessage.error('获取对话记录失败')
      // 使用模拟数据作为后备
      chatHistoryList.value = [
        {
          id: 1,
          role: 'user',
          content: '你好，我想咨询一下关于透析的问题',
          timestamp: '2024-01-15 10:30:00',
          createdAt: '2024-01-15 10:30:00'
        },
        {
          id: 2,
          role: 'assistant', 
          content: '您好！我是您的AI健康助手，很高兴为您服务。请问您想了解透析的哪个方面呢？',
          timestamp: '2024-01-15 10:30:05',
          createdAt: '2024-01-15 10:30:05'
        }
      ]
    }
  } finally {
    if (!isLoadMore) {
      chatHistoryLoading.value = false
    }
  }
}

// 修改 loadMoreChatHistory 方法，保持滚动位置
const loadMoreChatHistory = async () => {
  if (!hasMoreChatHistory.value) {
    ElMessage.info('没有更多聊天记录了')
    return
  }
  
  if (isLoadingMore.value || chatHistoryLoading.value) {
    console.log('正在加载中，跳过重复请求')
    return
  }
  
  isLoadingMore.value = true
  console.log('开始加载更多聊天记录')
  
  // 记录当前滚动位置和内容高度
  const container = chatHistoryContainer.value
  if (!container) {
    isLoadingMore.value = false
    return
  }
  
  const oldScrollTop = container.scrollTop
  const oldScrollHeight = container.scrollHeight
  
  try {
    await fetchChatHistory(true) // 传入true表示加载更多
    
    // 等待DOM更新后调整滚动位置
    await nextTick()
    
    // 计算新内容的高度差
    const newScrollHeight = container.scrollHeight
    const heightDiff = newScrollHeight - oldScrollHeight
    
    // 调整滚动位置，保持用户当前查看的内容位置不变
    // 新内容添加在顶部，所以需要向下偏移新增内容的高度
    container.scrollTop = oldScrollTop + heightDiff
    
    console.log('滚动位置调整:', {
      oldScrollTop,
      oldScrollHeight,
      newScrollHeight,
      heightDiff,
      newScrollTop: container.scrollTop
    })
    
  } catch (error) {
    console.error('加载更多失败:', error)
  } finally {
    isLoadingMore.value = false
  }
}

// 格式化时间显示
const formatTime = (timeStr) => {
  if (!timeStr) return ''
  const date = new Date(timeStr)
  if (isNaN(date.getTime())) return timeStr
  
  // 格式化为 YYYY-MM-DD HH:mm:ss
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

const deletePatient = async (row) => {
  ElMessageBox.confirm(
    `确定要删除患者 ${row.name} 吗？`,
    '警告',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(async () => {
    try {
      const response = await patientAPI.deletePatient({ userId: row.userId })
      if (response.code === 0) {
        ElMessage.success('删除成功')
        fetchPatientList() // 重新获取列表
      } else {
        ElMessage.error(response.msg || '删除失败')
      }
    } catch (error) {
      ElMessage.error('删除失败')
      console.error('删除患者错误:', error)
    }
  }).catch(() => {
    ElMessage.info('已取消删除')
  })
}

const savePatient = async () => {
  if (!patientForm.name || !patientForm.phone || patientForm.dryWeight === undefined || !patientForm.birthday || patientForm.organizationId === null || patientForm.organizationId === undefined || patientForm.organizationId === '') {
    ElMessage.error('请填写完整信息')
    return
  }
  
  try {
    let response
    if (isEdit.value) {
      response = await patientAPI.updatePatient({
        userId: patientForm.userId,
        phone: patientForm.phone,
        name: patientForm.name,
        dryWeight: patientForm.dryWeight,
        gender: patientForm.gender,
        birthday: patientForm.birthday,
        organizationId: patientForm.organizationId,
        remark: patientForm.remark || ''
      })
    } else {
      // 新增患者
      response = await patientAPI.addPatient({
        phone: patientForm.phone,
        name: patientForm.name,
        dryWeight: patientForm.dryWeight,
        gender: patientForm.gender,
        birthday: patientForm.birthday,
        organizationId: patientForm.organizationId,
        remark: patientForm.remark || ''
      })
    }
    
    if (response.code === 0) {
      ElMessage.success(isEdit.value ? '编辑成功' : '新增成功')
      patientDialogVisible.value = false
      fetchPatientList() // 重新获取列表
    } else {
      ElMessage.error(response.msg || (isEdit.value ? '编辑失败' : '新增失败'))
    }
  } catch (error) {
    ElMessage.error(isEdit.value ? '编辑失败' : '新增失败')
    console.error('保存患者信息错误:', error)
  }
}

// 发送通知相关功能
const sendNotification = () => {
  if (selectedPatients.value.length === 0) {
    ElMessage.warning('请先选择要发送通知的用户')
    return
  }
  
  Object.assign(notificationForm, {
    content: '',
    sendTime: new Date().toISOString().slice(0, 19).replace('T', ' ')
  })
  notificationDialogVisible.value = true
}

const removeUser = (user) => {
  const index = selectedPatients.value.findIndex(p => p.id === user.id)
  if (index > -1) {
    selectedPatients.value.splice(index, 1)
  }
}

const openDoctorCommentDialog = (message) => {
  doctorCommentForm.messageId = message.id
  doctorCommentDialogVisible.value = true
  currentAiNotification.value = message.content
  currentTime.value = message.timestamp
}

const submitDoctorComment = async () => {
  if (!doctorCommentForm.content) {
    ElMessage.error('请输入医生意见')
    return
  }
  
  try {
    const answer = chatHistoryList.value.find(message => message.role === 'user' && message.timestamp === currentTime.value)?.content || ''
    console.log({
      content:doctorCommentForm.content,
      answer:answer,
      time:currentTime.value,
      messageId:doctorCommentForm.messageId
    })
    const data ={
      content: answer,
      answer:doctorCommentForm.content,
      messageId:doctorCommentForm.messageId
    }

    const data2 = {
      content:"AI对话修正",
      type: 1,
      data:data
    }
    
    const  response  = await approvalAPI.submitApproval("",data2)
    
    if(response.code==0){
      ElMessage.success('医生意见提交成功')
    }else{
      ElMessage.error('提交医生意见失败')
    }
    doctorCommentDialogVisible.value = false
    doctorCommentForm.content = ''
  } catch (error) {
    ElMessage.error('提交医生意见失败')
    console.error('提交医生意见错误:', error)
  }
}

const formatDate=()=> {
  const date = new Date();
  const pad = (n) => n.toString().padStart(2, "0");

  return (
    date.getFullYear() + "-" +
    pad(date.getMonth() + 1) + "-" +
    pad(date.getDate()) + " " +
    pad(date.getHours()) + ":" +
    pad(date.getMinutes()) + ":" +
    pad(date.getSeconds())
  );
}

const sendNotificationSubmit = async () => {

  if (!notificationForm.title) {
    ElMessage.error('请填写通知标题')
    return
  }
  
  if (!notificationForm.content) {
    ElMessage.error('请填写通知内容')
    return
  }
  
  if (selectedPatients.value.length === 0) {
    ElMessage.error('请选择接收用户')
    return
  }
  
  sending.value = true
  try {
    // 获取选中用户的ID数组
    const receiverIds = selectedPatients.value.map(patient => String(patient.id))
    
    const messageData = {
      content: notificationForm.content,
      receiverIds: JSON.stringify(receiverIds), // 用户ID数组
      sendTime: notificationForm.sendTime || formatDate(),
      title:notificationForm.title
    }
    
    const response = await messageAPI.addMessage(messageData)
    
    if (response.code === 0) {
      notificationDialogVisible.value = false
      
      if (notificationForm.sendTime) {
        ElMessage.success(`通知已安排发送，发送时间：${notificationForm.sendTime}`)
      } else {
        ElMessage.success('通知发送成功')
      }
      
      // 清空选中的用户
      selectedPatients.value = []
    } else {
      ElMessage.error(response.msg || '发送通知失败')
    }
  } catch (error) {
    console.error('发送通知错误:', error)
    ElMessage.error('发送通知失败')
  } finally {
    sending.value = false
  }
}

// 搜索功能
const handleSearch = () => {
  currentPage.value = 1
  fetchPatientList()
}

// 重置功能
const handleReset = () => {
  Object.assign(filterForm, {
    name: '',
    phone: '',
    organizationId: null
  })
  handleSearch()
}

// 分页处理
const handleSizeChange = (val) => {
  pageSize.value = val
  currentPage.value = 1
  fetchPatientList()
}

const handleCurrentChange = (val) => {
  currentPage.value = val
  fetchPatientList()
}

// 组件挂载时获取患者列表
onMounted(async () => {
  await fetchOrganizationOptions()
  await fetchPatientList()
})
</script>

<style scoped>
.patient-page {
  padding: 20px;
}

.page-header {
  margin-bottom: 30px;
}

.page-header h1 {
  font-size: 28px;
  color: #1e293b;
  margin: 0 0 10px 0;
}

.page-header p {
  color: #64748b;
  margin: 0;
}

.patient-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  /* margin: 20px; */
  width: 60%;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 16px;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.stat-label {
  color: #64748b;
  margin-bottom: 8px;
}

.stat-trend {
  font-size: 14px;
  font-weight: 500;
}

.stat-trend.positive {
  color: #10b981;
}

.stat-trend.negative {
  color: #ef4444;
}

.stat-trend.neutral {
  color: #6b7280;
}

.user-list-section1 {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0;
  margin-bottom: 20px;
}

.section-header h2 {
  margin: 0;
  color: #1e293b;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.selected-users {
  min-height: 40px;
  padding: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fafafa;
}

.user-count {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}

.pagination-wrapper {
  padding: 20px;
  display: flex;
  justify-content: center;
}

.patient-stats .stat-card {
  padding: 16px;
}

.patient-stats .stat-icon .el-icon {
  font-size: 18px;
}

.patient-stats .stat-content .stat-number {
  font-size: 28px;
}

.patient-stats .stat-label {
  font-size: 12px;
}

.patient-stats .stat-trend {
  font-size: 12px;
}

/* 聊天记录对话框样式 */
.chat-history-container {
  max-height: 500px;
  overflow-y: auto;
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 8px;
  color: #409eff;
}

.empty-chat {
  padding: 40px 0;
}

.chat-messages {
  padding: 0 4px;
}

.chat-message {
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  max-width: 80%; /* 限制最大宽度 */
  width: fit-content; /* 根据内容自适应宽度 */
}

.chat-message.user-message {
  background-color: #e3f2fd;
  border-color: #2196f3;
  margin-left: auto; /* 靠右显示 */
  margin-right: 0;
  text-align: right; /* 文字右对齐 */
  max-width: 70%; /* 患者消息最大宽度稍小一些 */
}

.chat-message.assistant-message {
  background-color: #f5f5f5;
  border-color: #d0d0d0;
  margin-left: 0;
  margin-right: auto; /* 靠左显示 */
  text-align: left; /* 文字左对齐 */
  max-width: 80%; /* AI助手消息可以更宽一些 */
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
}

/* 患者消息的头部样式 */
.user-message .message-header {
  flex-direction: row-reverse; /* 反转顺序，时间在左，角色在右 */
}

.user-message .message-role {
  color: #2196f3;
  order: 2; /* 角色名称在右边 */
}

.user-message .message-time {
  color: #909399;
  order: 1; /* 时间在左边 */
}

/* AI助手消息的头部样式 */
.assistant-message .message-header {
  flex-direction: row; /* 正常顺序，角色在左，时间在右 */
}

.assistant-message .message-role {
  color: #67c23a;
  order: 1; /* 角色名称在左边 */
}

.assistant-message .message-time {
  color: #909399;
  order: 2; /* 时间在右边 */
}

.message-content {
  line-height: 1.6;
  color: #303133;
  white-space: pre-wrap;
  word-break: break-word;
}

/* 患者消息内容右对齐 */
.user-message .message-content {
  text-align: right;
}

/* AI助手消息内容左对齐 */
.assistant-message .message-content {
  text-align: left;
}

/* 问题样式 */
.message-content .question {
  font-weight: 600;
  color: #409eff;
  margin: 16px 0 12px 0;
  font-size: 14px;
}

/* 按钮样式 */
.message-content view {
  display: inline-block;
  margin: 4px 8px 4px 0;
}

.message-content .btn-click-sel {
  display: inline-block;
  padding: 8px 16px;
  background-color: #f0f9ff;
  border: 1px solid #0ea5e9;
  border-radius: 6px;
  color: #0ea5e9;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
}

.message-content .btn-click-sel:hover {
  background-color: #0ea5e9;
  color: white;
}

.message-content .btn-click-sel:active {
  background-color: #0284c7;
  border-color: #0284c7;
}

/* 滚动条样式 */
.chat-history-container::-webkit-scrollbar {
  width: 6px;
}

.chat-history-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.chat-history-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.chat-history-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 加载更多的提示样式 */
.loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  gap: 8px;
  color: #409eff;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

/* 确保滚动容器有合适的高度 */
.chat-history-container {
  max-height: 500px;
  overflow-y: auto;
  position: relative;
}

/* 加载更多记录按钮样式 */
.load-more-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  margin: 8px;
  background-color: #f8f9fa;
  border: 1px dashed #d0d0d0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  gap: 8px;
  color: #409eff;
  font-size: 14px;
}

.load-more-button:hover {
  background-color: #e6f7ff;
  border-color: #409eff;
  color: #1890ff;
}

.load-more-button:active {
  background-color: #bae7ff;
  transform: translateY(1px);
}

.load-more-button .el-icon {
  font-size: 16px;
}

.filter-section {
  padding: 0 24px 20px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 20px;
}

/* 对话框头部样式 */
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.agent-selector {
  display: flex;
  align-items: center;
  gap: 8px;
}

.agent-selector .el-radio {
  margin-right: 10px; /* 调整单选框之间的间距 */
}

@media (max-width: 768px) {
  .patient-stats {
    grid-template-columns: 1fr;
  }
  
  .section-header {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .header-actions {
    justify-content: center;
  }
}

.message-actions{
  display: flex;
  justify-content: end;

}
</style> 
